<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
	@import 'assets/animate.css';
	@import url('https://fonts.googleapis.com/css?family=Barlow+Semi+Condensed:400,500,700,800,900');
	*, html {
		padding: 0;
		margin: 0;
		vertical-align: top;
	}
	a, a:hover, a:active, a:active {
		color: #fff;
		text-decoration: none;
	}
	body {	
		font-family: 'Barlow Semi Condensed', sans-serif;
	}
	
</style>



// WEBPACK FOOTER //
// src/App.vue